import { useBudouX } from "@/hooks/useBudouX";
import { Br } from "../molecules/Br";

export const AboutPhilosophy = (props) => {
  const { parse } = useBudouX();
  return (
    <div id="identity" className="--offset">
      <div className="relative mx-auto box-border max-w-7xl space-y-8">
        <div className="grid grid-cols-1 gap-4 px-6 sm:px-8 md:grid-cols-1 md:px-12 xl:px-0">
          <div className="col-span-1">
            <h3 className="border-b font-bold text-ter fluid-text-[16px,18px]">
              Identity
            </h3>
            <div className="flex flex-col items-start justify-start gap-8 divide-y divide-bdc-base">
              {/* ミッション */}
              <div className="flex w-full flex-col items-start justify-start gap-4 pt-8">
                {/* Label */}
                <div className="flex flex-col items-start justify-center gap-1 text-ter">
                  <h6 className="font-bold fluid-text-[10px,11px]">
                    ミッション
                  </h6>
                  <h6 className="leading-0 font-bold fluid-text-[14px,16px]">
                    mission
                  </h6>
                </div>
                {/* Lead */}
                <h3 className="leading-0 self-stretch font-serif font-bold text-pri fluid-text-[22px,39px]">
                  思いと技術で未来を創る
                </h3>
                {/* BodyText */}
                <div className="grid w-full grid-cols-1 md:grid-cols-4">
                  <span className="hidden md:col-span-1 md:block"></span>
                  <div className="col-span-1 leading-loose text-txt-base fluid-text-[14px,18px] md:col-span-3">
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      お客さまの「実現したいという思い」と様々な「技術」をつなぎ、あらゆる関係者と共に、
                      <Br pc />
                      サービスやシステムを構築し、新たな価値を創造し、社会に貢献する。
                    </p>
                  </div>
                </div>
              </div>
              {/* ビジョン */}
              <div className="flex w-full flex-col items-start justify-start gap-4 pt-8">
                {/* Label */}
                <div className="flex flex-col items-start justify-center gap-1 text-ter">
                  <h6 className="font-bold fluid-text-[10px,11px]">ビジョン</h6>
                  <h6 className="leading-0 font-bold fluid-text-[14px,16px]">
                    vision
                  </h6>
                </div>
                {/* Lead */}
                <h3 className="leading-0 self-stretch font-serif font-bold text-pri fluid-text-[22px,39px]">
                  思いを未来につないでゆく
                </h3>
                {/* BodyText */}
                <div className="grid w-full grid-cols-1 md:grid-cols-4">
                  <div className="col-span-1 hidden md:block"></div>
                  <div className="col-span-1 space-y-1 leading-loose md:col-span-3 md:space-y-4">
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      お客さまと私たち一人一人が真摯に向き合い、同じ目線で、
                      <Br pc />
                      共に取り組んでいくことで、創造する価値を高め続ける。
                    </p>
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      そのためには変化を恐れず、
                      <Br pc />
                      一人一人が主体性と、お客さまへの貢献の姿勢を持ち、
                      <Br pc />
                      常にユーザ目線で誠実に取り組む。
                    </p>
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      私たちは「実現したい思い」と「技術」、
                      <Br pc />
                      そして「人」を軸として、そこに携わる人と企業、社会をつなぐ。
                    </p>
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      世の中の幸せを生み出し育て、支え続けていくための、
                      <Br pc />
                      エンジニアリングプラットフォーム企業を目指します。
                    </p>
                  </div>
                </div>
              </div>
              {/* ミッション */}
              <div className="flex w-full flex-col items-start justify-start gap-4 pt-8">
                {/* Label */}
                <div className="flex flex-col items-start justify-center gap-1 text-ter">
                  <h6 className="font-bold fluid-text-[10px,11px]">バリュー</h6>
                  <h6 className="leading-0 font-bold fluid-text-[14px,16px]">
                    value
                  </h6>
                </div>
                {/* Lead */}
                <h3 className="leading-0 self-stretch font-serif font-bold text-pri fluid-text-[22px,39px]">
                  思いを形にする力
                </h3>
                {/* BodyText */}
                <div className="grid w-full grid-cols-1 md:grid-cols-4">
                  <span className="hidden md:col-span-1 md:block"></span>
                  <div className="col-span-1 space-y-1 leading-loose md:col-span-3 md:space-y-4">
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      私たちの生活は急速に変化を続けています。
                    </p>
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      生活を支える仕組み、仕組みを支える技術もまた、進化・成長を続けなくてはなりません。
                      <Br pc />
                      今や、単一の技術だけでは、ほとんどのことが実現できなくなっています。
                    </p>
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      ユーザ視点に立ち、柔軟な発想を持ち、プロジェクトを実現する力。
                      <Br pc />
                      その力を支える技術力と推進力。そして技術とビジネスを「つなぐ力」が求められています。
                    </p>
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      私たちは「つなぐ力」を軸として、特に必要性や重要性の高い分野で技術を磨きます。
                      <Br pc />
                      お客さまと意思を通わせ、プロジェクトを円滑に進めます。
                      <Br pc />
                      必要に応じて柔軟に、プロダクトやサービスに昇華させながら、より高いパフォーマンスのサービスやシステムを実現し、お客さまの思いを形にします。
                    </p>
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      私たちは手段に捉われず、目的志向で価値を発揮することを旨として行動します。
                      <Br pc />
                      そして、技術が宿り「実現」するのは、常に「人」であることを忘れず、同じ志を持ち、
                      <Br pc />
                      共に歩むことができる「人々」が集い、互いに成長し価値を共有します。
                    </p>
                    <p className="leading-8 text-txt-base fluid-text-[14px,18px]">
                      技術と成長を志す「人」が集まる企業として、
                      <Br pc />
                      そこに携わる「人々」の実現者としての喜びを創造します。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
